import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

export const start = () => {
  Bugsnag.start({
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact(React)],
    releaseStage: process.env.REACT_APP_ENV || 'local',
  });
};

export const setUser = (employee: $TSFixMe) => {
  Bugsnag.setUser(
    employee.id,
    employee.email,
    `${employee.first_name} ${employee.last_name}`
  );
};

export const notify = (error: $TSFixMe) => {
  Bugsnag.notify(error);
};

export const createErrorBoundary = () =>
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  Bugsnag.getPlugin('react').createErrorBoundary(React);
